import './polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import AuthContext, { AuthService } from './msal'
import axios from 'axios'
import { singIn } from './services/session/authConfig'
import { setSystemConfig } from './services/session/systemConfig'
import CartProvider from './context/cart.context'
import OrderTrackingProvider from './context/orderTracking.context'
import Page500 from './views/Pages/Page500/Page500'
import UserAccountsProvider from './context/userAccounts.context'
import { getUserAccountsSingleton } from './services/userAccountsSingleton.service'

const timeToWaitForTokenInMilliseconds = 1000
const msal = new AuthService(null)

const LoadApp = (isAuthenticated, msal) => {
  if (!isAuthenticated) {
    msal.signIn().then((r) => {})
  } else {
    axios
      .post(process.env.REACT_APP_API_URL + '/api/Token')
      .then((result) => {
        singIn(result.data.data)
      })
      .then(() => setSystemConfig())
      .then(() => getUserAccountsSingleton())
      .then(() =>
        ReactDOM.render(
          <AuthContext.Provider value={msal}>
            <CartProvider>
              <OrderTrackingProvider>
                <UserAccountsProvider>
                  <App />
                </UserAccountsProvider>
              </OrderTrackingProvider>
            </CartProvider>
          </AuthContext.Provider>,
          document.getElementById('root')
        )
      )
      .catch((err) => {
        ReactDOM.render(
          <Page500 message={err.message} msal={msal} />,
          document.getElementById('root')
        )
      })
  }
}

const IsAuthenticatedTimeOut = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(msal.isAuthenticated())
    }, timeToWaitForTokenInMilliseconds)
  })
  return promise
}

IsAuthenticatedTimeOut(msal).then((isAuthenticated) => LoadApp(isAuthenticated, msal))
